import React from 'react';
import { Box, Paper, Stack, Link } from '@mui/material';
import BadgeOutlined from '@mui/icons-material/BadgeOutlined';
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined';
import NotesOutlined from '@mui/icons-material/NotesOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { SectionHeader } from './SectionHeader';
import SiteNameCodeFields from './SiteNameCodeFields';
import What3WordsField from './What3WordsField';
import NotesField from './NotesField';

const SiteInformationStep: React.FC = () => (
  <Box data-testid="site-information-step">
    <Stack spacing={3}>
      <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
        <Stack spacing={2.5}>
          <SectionHeader
            icon={<BadgeOutlined />}
            title="Identity"
            description="Give your site a name and a unique 4-character code"
          />
          <SiteNameCodeFields />
        </Stack>
      </Paper>

      <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
        <Stack spacing={2.5}>
          <SectionHeader
            icon={<LocationOnOutlined />}
            title="Location"
            description="Helps your team navigate directly to the site in the app"
          />
          <Link
            href="https://what3words.com"
            target="_blank"
            rel="noopener noreferrer"
            variant="caption"
            sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
            data-testid="what3words-external-link"
          >
            Don&apos;t know your address? Find it on what3words.com
            <OpenInNewIcon sx={{ fontSize: 12 }} />
          </Link>
          <What3WordsField />
        </Stack>
      </Paper>

      <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
        <Stack spacing={2.5}>
          <SectionHeader
            icon={<NotesOutlined />}
            title="Notes"
            description="Optional description or additional information about the site"
          />
          <NotesField />
        </Stack>
      </Paper>
    </Stack>
  </Box>
);

export default SiteInformationStep;
